import { view } from '@risingstack/react-easy-state'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import PropertyMap from '../../../components/property-map/property-map'
import GenericPageContainer from '../../../GenericPageElements/GenericPageContainer'
import request from '../../../helpers/request'
import Summary from '../../../components/ap-generics/components/GenericSummaryComponent'
import {CMOSLive} from '../../../components/ap-generics/components/evidence-tables/CMOSLive'
import { AddressBase } from '../../../components/ap-generics/components/evidence-tables/AddressBase'
import { ValuationOfficeAndCouncilTax } from '../../../components/ap-generics/components/evidence-tables/ValuationOfficeAndCouncilTax'
import { MeterAddress } from '../../../components/ap-generics/components/evidence-tables/MeterAddress'
import { CMOSFormatted } from '../../../components/ap-generics/components/evidence-tables/CMOSFormatted'
import { MDS } from '../../../components/ap-generics/components/evidence-tables/MDS'
import { ConfirmModal } from '../../../components/ap-generics/components/modals/ConfirmModal.jsx'
import useMDSData from '../../../components/ap-generics/hooks/useMDSData'
import LinkedReferenceTable from '../../../components/linked-reference-table/LinkedReferenceTable.jsx'

export default view(function UndeliverableWorkflow() {
  const [summaryData, setSummaryData] = useState({})
  const [selectedMatches, setSelectedMatches] = useState({abp: '', voa: '', ct: ''})
  const [confirmModal, setConfirmModal] = useState(false)
  const [cmosUserInput, setCmosUserInput] = useState({})
  const [meterUserInput, setMeterUserInput] = useState({})
  const [disabledByUserType, setDisabledByUserType] = useState(true)
  const prefix = "UNDELIVERABLE"
  const {mdsData, setMdsData, mdsDataReady, setMdsDataReady, mdsMeterData, setMdsMeterData, customMDSPostcode, setCustomMDSPostcode, getMDSData} = useMDSData(summaryData, prefix)
  const [translations, setTranslations] = useState({})

  useEffect(() => {
    request(true).get('/translate?key=mosl_eligibility')
    .then(e => {
      setTranslations(e.data)
    })
    }, [])
    useEffect(() => {
      setSelectedMatches({abp: '', voa: '', ct: ''})
    }, [summaryData.Core_SPID])

  return (
    <GenericPageContainer
    containerWidth={"95vw"}
      title="Non-Addressable - Workflow"
      titleIconClass={"fak fa-id-business-icon fa-2x colour-primary"}
      titleRight={
        <div>
          <Link className="navigate" to="/portal/undeliverable">
              To Summary
          </Link>
          <Link className="navigate" to="/portal/undeliverable/search">
              To Search
          </Link>
        </div>
      }
    >
      <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
        <div style={{display: 'grid', gap: 10}}>
          <Summary translations={translations} summaryData={summaryData} setSummaryData={setSummaryData} workflow={true} setMdsData={setMdsData} setMdsDataReady={setMdsDataReady} getMDSData={() => getMDSData(summaryData, setMdsDataReady, prefix, customMDSPostcode, setMdsData, setMdsMeterData)} setConfirmModal={setConfirmModal} prefix={prefix} setDisabledByUserType={setDisabledByUserType} disabledByUserType={disabledByUserType} setMdsMeterData={setMdsMeterData} customMDSPostcode={customMDSPostcode} />
        </div>

        <div style={{display: 'grid', gridAutoColumns: '1fr', gridAutoFlow: 'column', gap: 10}}>
          <CMOSLive translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} />
          <AddressBase translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} setUserInput={setCmosUserInput} />
          <ValuationOfficeAndCouncilTax translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} setUserInput={setCmosUserInput} />
          <MeterAddress translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} userInput={meterUserInput} setUserInput={setMeterUserInput} />
          <CMOSFormatted translations={translations} summaryData={summaryData} setSummaryData={setSummaryData} workflow={true} selectedMatches={selectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} userInput={cmosUserInput} setUserInput={setCmosUserInput} meterInput={meterUserInput} />
        </div>
        <div>
          <ConfirmModal confirmModal={confirmModal} setConfirmModal={setConfirmModal} prefix={prefix} summaryData={summaryData} setSummaryData={setSummaryData} cmosUserInput={cmosUserInput} meterUserInput={meterUserInput} />
        </div>
        <LinkedReferenceTable summaryData={summaryData} translations={translations} prefix={prefix} />
        <MDS data={ mdsData } MDSDataReady={ mdsDataReady } getData={ () => getMDSData(summaryData, setMdsDataReady, prefix, customMDSPostcode, setMdsData, setMdsMeterData) } customPostcode={ customMDSPostcode } setCustomPostcode={ setCustomMDSPostcode } style={{ fontSize: '14px' }} classes={"squish"} SPID={summaryData?.Core_SPID} /> 
        <div style={{minHeight: '40vh', marginBottom: '10em'}}>
          <PropertyMap 
            translations={translations} 
            eastingNorthing={summaryData && summaryData.CMOS_UPRN_GISX && summaryData.CMOS_UPRN_GISY && [parseInt(summaryData.CMOS_UPRN_GISX), parseInt(summaryData.CMOS_UPRN_GISY)]} 
            address={summaryData['CMOS_Address_Single_Line'] ?? summaryData['CMOS_Meter_Address_Single_Line']} 
            uprnEastingNorthing={summaryData && summaryData.Matched_UPRN_GISX && summaryData.Matched_UPRN_GISY ? [parseInt(summaryData.Matched_UPRN_GISX), parseInt(summaryData.Matched_UPRN_GISY)] : null} 
            meterEastingNorthing={summaryData && summaryData.CMOS_Meter_GISX && summaryData.CMOS_Meter_GISY  ? [parseInt(summaryData.CMOS_Meter_GISX), parseInt(summaryData.CMOS_Meter_GISY )] : null} 
            displayExtraPins={true} 
            matchedUprnText={true}
            mdsMeterData={mdsMeterData}
            showAllMeters={true}
          />
        </div>
      </div>
    </GenericPageContainer>    
  )
})
